// extracted by mini-css-extract-plugin
export default {"container":"LabelWithInput_container__8Thmq","inline":"LabelWithInput_inline__sotMs","label":"LabelWithInput_label__Z2ppe","input":"LabelWithInput_input__9pMvH"};